import { RouterView } from 'vue-router';
export default function FinanceServiceRoutes(staticTitle) {
    return [
        {
            path: '/financeservice/finance',
            meta: {
                title: `${staticTitle} - Finance`
            },
            component: RouterView,
            children: [
                {
                    path: 'budget',
                    name: 'budget',
                    meta: {
                        title: `Finance Service - Budget`
                    },
                    component: () => {
                        return import('@/views/finance/budget/index.vue');
                    }
                },
                {
                    path: 'report',
                    name: 'report',
                    meta: {
                        title: `Finance Service - Report`
                    },
                    component: () => {
                        return import('@/views/finance/report/index.vue');
                    }
                },
                {
                    path: 'master',
                    name: 'master',
                    meta: {
                        title: `Finance Service - Master`
                    },
                    component: () => {
                        return import('@/views/finance/master/index.vue');
                    }
                }
            ]
        }
    ];
}
